/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {ReactNode} from "react";
import {GroupedCompetitionItem} from "types/entities/GroupedPackageItem";
import CompetitionsList from "pages/Front/Booking/Competitions/CompetitionsList";
import clsx from "clsx";

interface CompetitionsSectionProps {
    competitions: GroupedCompetitionItem[];
    title: string;
    badge: string;
    subtitle?: ReactNode;
    counter?: string;
    isCounterComplete?: boolean;
    badgeColor?: "green" | "blue";
    children?: ReactNode;
}

const CompetitionsSection = (props: CompetitionsSectionProps) => {
    if (props.competitions.length === 0 && !props.children) {
        return <></>;
    }

    return (
        <div className={"CompetitionsSection flex flex-col gap-y-3 sm:gap-y-4 w-full"}>
            <div className={"flex flex-col lg:flex-row lg:items-center gap-x-3 gap-y-2 w-full px-1"}>
                <div className={"flex flex-row items-center gap-x-3 shrink-0"}>
                    <img alt={"Competitions"} className={"size-[40px] flex-none"} src={"/img/competitions/competitions-trophy.svg"} />
                    <div className={"flex flex-col xs:flex-row xs:items-center gap-x-3 gap-y-2"}>
                        <h2 className={"text-xl sm:text-2xl font-bold text-black leading-none"}>{props.title}</h2>
                        <span className={clsx("rounded-full px-2 py-1 text-[10px] font-bold whitespace-nowrap self-baseline xs:self-center", props.badgeColor === "green" ? "bg-[#8EDF2B] text-black" : "bg-[#D5D9F0] text-black")}>{props.badge}</span>
                    </div>
                </div>

                <div className={"flex flex-col sm:flex-row sm:items-center gap-x-3 gap-y-2 grow w-full"}>
                    {props.subtitle && <div className={"text-xs sm:text-sm font-medium text-gray-700 grow"}>{props.subtitle}</div>}
                    {props.counter && (
                        <span className={clsx("text-base font-semibold whitespace-nowrap sm:ml-auto", props.isCounterComplete ? "text-[#3AA90D]" : "text-black")}>
                            {props.counter}
                        </span>
                    )}
                </div>
            </div>

            <CompetitionsList competitions={props.competitions} />
            {props.children}
        </div>
    );
};

export default CompetitionsSection;
